export default "__VITE_ASSET__CSl50swo__"